import Vue from 'vue'

export default function removeStudentFromGroup({ student_id, group_id, comment }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/students/" + student_id + "/group/" + group_id + "/remove"
    return Vue.http
        .patch(url, { comment }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response).catch(() => { throw "Ошибка сохранения" })
}